import { types } from "../../types/types";

export const initialState = {
  logo_register: "",
  logo_navbar: "",
  logo_login: "",
  logo_footer: "",
  banner_politics: "",
  colors: {},
  rounded: {},

  // navbar_color: "",
  // bg_screen: "",
  // screen_text_color: "",
  // alert_color: "",
  // alert_text_color: "",
  // bg_footer: "",
  // footer_text_color: "",
  // bg_btn_guardar: "",
  // btn_guardar_text_color: "",
  // bg_hoover_btn_guardar: "",
  // btn_guardar_hoover_text_color: "",

  url_peritaje_sala: "",
  data_informed_consent: "",
  data_assurance: "",
  data_recommendations: "",
  data_times: "",
  data_refund: "",
  data_rights: "",
  data_duties: "",
  data_faqs: "",
  data_use_our_website: "",
  data_information_security: "",
  data_user: "",
  data_modifications: "",
  data_restrictions: "",
  data_contents: "",
  data_guarantees_responsabilities: "",
  data_cookies: "",
  data_duration_termination: "",
  data_user_compensation: "",
  data_legislation_jurisdiction: "",
  data_protection: "",
  data_mexico_politics: "",
  data_elements_politics: "",
  data_glossary_terms: "",
  data_privacy_notice_mexico: "",
  data_col_politics: "",
  data_glossary_col: "",
  data_proccesing_personal_data: "",
  data_rights_holders: "",
  data_duties_treatment: "",
  data_security_measures: "",
  data_images_carousel: "",
};

export const configReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.loadLogoRegister:
      return {
        ...state,
        logo_register: action.payload,
      };

    case types.loadLogoNavbar:
      return {
        ...state,
        logo_navbar: action.payload,
      };

    case types.loadLogoLogin:
      return {
        ...state,
        logo_login: action.payload,
      };

    case types.loadLogoFooter:
      return {
        ...state,
        logo_footer: action.payload,
      };

    case types.loadBannerPolitics:
      return {
        ...state,
        banner_politics: action.payload,
      };

    // case types.loadNavbarColor:
    //   return {
    //     ...state,
    //     navbar_color: action.payload,
    //   };

    // case types.loadBackgroundScreen:
    //   return {
    //     ...state,
    //     bg_screen: action.payload,
    //   };

    // case types.loadScreenTextColor:
    //   return {
    //     ...state,
    //     screen_text_color: action.payload,
    //   };

    // case types.loadAlertColor:
    //   return {
    //     ...state,
    //     alert_color: action.payload,
    //   };

    // case types.loadAlertTextColor:
    //   return {
    //     ...state,
    //     alert_text_color: action.payload,
    //   };

    // case types.loadBackgroundFooter:
    //   return {
    //     ...state,
    //     bg_footer: action.payload,
    //   };

    // case types.loadFooterTextColor:
    //   return {
    //     ...state,
    //     footer_text_color: action.payload,
    //   };

    // case types.loadBgBtnGuardar:
    //   return {
    //     ...state,
    //     bg_btn_guardar: action.payload,
    //   };

    // case types.loadTextColorBTNGuardar:
    //   return {
    //     ...state,
    //     btn_guardar_text_color: action.payload,
    //   };

    // case types.loadBgHooverBtnGuardar:
    //   return {
    //     ...state,
    //     bg_hoover_btn_guardar: action.payload,
    //   };

    // case types.loadTextColorHooverBtnGuardar:
    //   return {
    //     ...state,
    //     btn_guardar_hoover_text_color: action.payload,
    //   };

    case types.loadColors:
      return {
        ...state,
        colors: action.payload
      }

    case types.loadRounded:
      return {
        ...state,
        rounded: action.payload
      }

    case types.loadUrlPeritoSala:
      return {
        ...state,
        url_peritaje_sala: action.payload,
      };

    case types.loadDataInformedConsent:
      return {
        ...state,
        data_informed_consent: action.payload,
      };

    case types.loadDataAssurance:
      return {
        ...state,
        data_assurance: action.payload,
      };

    case types.loadDataRecommendations:
      return {
        ...state,
        data_recommendations: action.payload,
      };

    case types.loadDataTimes:
      return {
        ...state,
        data_times: action.payload,
      };

    case types.loadDataRefund:
      return {
        ...state,
        data_refund: action.payload,
      };

    case types.loadDataRights:
      return {
        ...state,
        data_rights: action.payload,
      };

    case types.loadDataDuties:
      return {
        ...state,
        data_duties: action.payload,
      };

    case types.loadDataFaqs:
      return {
        ...state,
        data_faqs: action.payload,
      };

    case types.loadDataUseOurWebsite:
      return {
        ...state,
        data_use_our_website: action.payload,
      };

    case types.loadDataInformationSecurity:
      return {
        ...state,
        data_information_security: action.payload,
      };

    case types.loadDataUser:
      return {
        ...state,
        data_user: action.payload,
      };

    case types.loadDataModifications:
      return {
        ...state,
        data_modifications: action.payload,
      };
    case types.loadDataRestrictions:
      return {
        ...state,
        data_restrictions: action.payload,
      };
    case types.loadDataContents:
      return {
        ...state,
        data_contents: action.payload,
      };
    case types.loadDataGuaranteesResponsabilities:
      return {
        ...state,
        data_guarantees_responsabilities: action.payload,
      };
    case types.loadDataCookies:
      return {
        ...state,
        data_cookies: action.payload,
      };
    case types.loadDataDurationTermination:
      return {
        ...state,
        data_duration_termination: action.payload,
      };
    case types.loadDataUserCompensation:
      return {
        ...state,
        data_user_compensation: action.payload,
      };
    case types.loadDataLegislationJurisdiction:
      return {
        ...state,
        data_legislation_jurisdiction: action.payload,
      };
    case types.loadDataProtection:
      return {
        ...state,
        data_protection: action.payload,
      };
    case types.loadDataMexicoPolitics:
      return {
        ...state,
        data_mexico_politics: action.payload,
      };
    case types.loadDataElementsPolitics:
      return {
        ...state,
        data_elements_politics: action.payload,
      };
    case types.loadDataGlossaryTerms:
      return {
        ...state,
        data_glossary_terms: action.payload,
      };
    case types.loadDataPrivacyNoticeMexico:
      return {
        ...state,
        data_privacy_notice_mexico: action.payload,
      };
    case types.loadDataColPolitics:
      return {
        ...state,
        data_col_politics: action.payload,
      };
    case types.loadDataGlossaryCol:
      return {
        ...state,
        data_glossary_col: action.payload,
      };
    case types.loadDataproccesingPersonalData:
      return {
        ...state,
        data_proccesing_personal_data: action.payload,
      };
    case types.loadDataRightsHolders:
      return {
        ...state,
        data_rights_holders: action.payload,
      };
    case types.loadDataDutiesTreatment:
      return {
        ...state,
        data_duties_treatment: action.payload,
      };
    case types.loadDataSecurityMeasures:
      return {
        ...state,
        data_security_measures: action.payload,
      };
    case types.loadDataImagesCarousel:
      return {
        ...state,
        data_images_carousel: action.payload,
      };

    default:
      return state;
  }
};
